<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20.81" height="21.685" viewBox="0 0 20.81 21.685">
    <g transform="translate(-265.095 -426.158)">
      <path
        d="M269.488,447.843h-.03a.5.5,0,0,1-.469-.529c.057-.971.009-3.75-.889-4.931-1.086-1.429-.869-5.079-.558-8.1l.041-.417c.231-2.444,1.512-3.675,3.8-3.619l.159,0c2.7.052,4.327.083,4.83,1.725.152.5.3.871.429,1.181a3.364,3.364,0,0,1,.357,1.49c-.035.678,0,6.135,0,6.191a.5.5,0,0,1-.5.5h0a.5.5,0,0,1-.5-.5c0-.226-.035-5.541,0-6.247a2.533,2.533,0,0,0-.286-1.066c-.134-.332-.294-.731-.457-1.262-.28-.913-1.331-.969-3.894-1.018l-.158,0c-1.728-.058-2.605.8-2.784,2.713l-.043.426c-.155,1.507-.627,6.093.36,7.39,1.306,1.719,1.1,5.439,1.091,5.6A.5.5,0,0,1,269.488,447.843Z"
        fill="#777"
      />
      <path
        d="M281.685,441.992h0a.5.5,0,0,1-.5-.5c0-1.329.013-4.747,0-5.331a3.053,3.053,0,0,0-1.95-1.951,3.182,3.182,0,0,0-2.246.784.5.5,0,0,1-.664-.748,4.168,4.168,0,0,1,3.039-1.03.52.52,0,0,1,.111.021,4.051,4.051,0,0,1,2.687,2.7.535.535,0,0,1,.021.125c.016.407,0,5.232,0,5.438A.5.5,0,0,1,281.685,441.992Z"
        fill="#777"
      />
      <path
        d="M285.4,442.555a.5.5,0,0,1-.5-.5v-4.872c0-.415-.409-.823-1.123-1.119-.591-.244-1.505.324-1.778.542a.5.5,0,1,1-.624-.781c.155-.125,1.549-1.2,2.785-.684,1.514.628,1.74,1.548,1.74,2.042v4.872A.5.5,0,0,1,285.4,442.555Z"
        fill="#777"
      />
      <path
        d="M272.343,436.162c-1.367,0-3.28-.1-3.488-.621-.041-.1-.138-.347-.035-4.321a.5.5,0,1,1,1,.025c-.039,1.482-.058,3.122-.034,3.751a26.7,26.7,0,0,0,3.885.136l.2-.013c.776-.048.776-.048,1.091-.359a10.356,10.356,0,0,0,.145-3.166.5.5,0,0,1,.468-.53.487.487,0,0,1,.53.469c.076,1.233.12,3.383-.439,3.937a2.025,2.025,0,0,1-1.734.647l-.2.013C273.717,436.131,273.118,436.162,272.343,436.162Zm-2.54-.931h0Z"
        fill="#777"
      />
      <path
        d="M279.918,436.979c-.372,0-.842-.035-1.439-.087-.342-.03-.646-.059-.816-.055a.79.79,0,0,1-.575-.257c-.465-.519-.357-1.877-.288-2.435a.5.5,0,1,1,.992.121,5.146,5.146,0,0,0,.014,1.574c.2.008.465.03.76.056a10.628,10.628,0,0,0,1.717.065,5.85,5.85,0,0,0-.118-1.235.5.5,0,0,1,.981-.194,3,3,0,0,1-.107,2.126C280.84,436.895,280.5,436.979,279.918,436.979Zm-2.078-1.057h0Z"
        fill="#777"
      />
      <path
        d="M283.98,437.621c-.039,0-.078,0-.119-.007-.423-.047-1.7-.013-2.152,0a.522.522,0,0,1-.517-.482.5.5,0,0,1,.482-.518c.175-.006,1.724-.059,2.3,0a1.2,1.2,0,0,0,.567-.463.5.5,0,0,1,.838.547A1.954,1.954,0,0,1,283.98,437.621Z"
        fill="#777"
      />
      <rect
        width="14"
        height="1"
        transform="translate(265.095 426.158)"
        fill="#777"
      />
      <rect
        width="1"
        height="2"
        transform="translate(265.095 427.158)"
        fill="#777"
      />
      <rect
        width="1"
        height="2"
        transform="translate(278.095 427.158)"
        fill="#777"
      />
    </g>
  </svg>
</template>
